import React, { Component } from 'react';
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import { is, Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component

import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { logPageView, initGA } from 'utils/analytics';
import ProfileHeader from 'components/ProfileHeader';
import ProfileData from 'components/ProfileData';
import Footer from 'components/MiniFooter';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import ProgressBar from 'react-toolbox/lib/progress_bar';
import Session from 'components/Session';

import style from './CoachAthleteView';
import { selector } from './redux';
import getSAProfile from './actions';


class CoachAthleteView extends Component {

  static propTypes = {
    profile: PropTypes.shape(),
    match: PropTypes.shape(),
    getSAProfile: PropTypes.func,
    requested: PropTypes.bool,
    attributes: PropTypes.shape().isRequired,
  };
  static defaultProps = {
    history: {},
    profile: Map(),
    getSAProfile: () => {},
    requested: false,
    match: {
      params: {
        id: '',
      },
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      isCoach: false,
    };
  }

  componentWillMount() {
    const id = this.props.match.params.id;
    if (id && id.length > 0) {
      this.props.getSAProfile(id);
    }
  }


  componentDidMount() {
    initGA();
    logPageView(this.props.match.path); // eslint-disable-line

    if (this.props.attributes && this.props.attributes.size > 0) {
      const zone = this.props.attributes.get('zoneInfo');
      if (zone === 'COACH') {
        this.setState({ isCoach: true }); // eslint-disable-line
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { attributes } = this.props;
    if (nextProps.attributes && !is(nextProps.attributes, attributes)) {
      const zone = nextProps.attributes.get('zoneinfo');
      if (zone === 'COACH') {
        this.setState({ isCoach: true });
      }
    }
    if (nextProps.profile.size > 0) {
      const saSports = nextProps.profile.get('sports');
      const keys = saSports.keySeq().toArray();
      const sport = saSports.get(keys[0]);

      const academic = nextProps.profile.get('academic');

      const newState = {
                // profile
        gender: nextProps.profile.get('gender'),
        fullname: nextProps.profile.get('fullname'),
        state: nextProps.profile.get('state'),
        city: nextProps.profile.get('city'),

                // sports
        height: nextProps.profile.get('height'),
        weight: nextProps.profile.get('weight'),
        sportName: keys[0],
        t40: sport.get('t40'),
        bench: sport.get('bench'),
        squats: sport.get('squats'),
        description: sport.get('description'),
        position_pref: sport.get('position_pref'),

                // school
        school: nextProps.profile.get('school'),
        year_of_graduation: academic.get('year_of_graduation'),
        gpa: academic.get('gpa'),
        sat: academic.get('sat'),
        act: academic.get('act'),

        profileId: nextProps.profile.get('id'),
        video: nextProps.profile.get('video_items').toJS(),

      };
      this.setState(newState);
    }
  }

  render() {
    const renderIfProfile = renderIf(this.props.profile.size > 0);
    const renderIfLoading = renderIf(this.props.requested);
    return (
      <div>
        {renderIfLoading(
          <div className={style.loaderContainer}>
            <span>
              <ProgressBar type="circular" mode="indeterminate" />
            </span>
          </div>,
          )}
        {renderIfProfile(
          <div className={cn('row', style.profileContainer)} >
            <ProfileHeader {...this.props} {...this.state} />
            <ProfileData {...this.props} {...this.state} />
            <Footer />
          </div>,
        )}
      </div>
    );
  }
}


export default connect(selector,
    { getSAProfile })(Session(CoachAthleteView));



// WEBPACK FOOTER //
// ./src/containers/CoachAthleteView/CoachAthleteView.js